import { clsx } from 'clsx'
import { ReactNode } from 'react'
import { ButtonVariant } from './Button'
import styles from './Button.module.scss'
import { Text } from './Text'

type LinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  variant?: ButtonVariant
  size?: 'default' | 'small'
  className?: string
  disabled?: boolean
}

export const Link = ({ variant = 'default', size = 'default', className, children, ...props }: LinkProps) => {
  return (
    <a
      className={clsx(
        styles.button,
        'justify-content transition-dh-all relative flex cursor-pointer items-center justify-center rounded-lg px-4 whitespace-nowrap select-none',
        variant === 'bordered' && styles.bordered,
        variant === 'bordered-gray' && styles.borderedGray,
        variant === 'secondary' && styles.secondary,
        variant === 'tertiary' && styles.tertiary,
        variant === 'green' && 'bg-green! border-green! hover:border-green-hover! hover:bg-green-hover! text-white',
        size === 'default' ? 'h-14' : `h-10 ${styles.small}`,
        className
      )}
      {...props}
    >
      <Text type="body1-semibold" color={variant === 'default' ? 'white' : undefined} className="transition-none">
        {children as ReactNode}
      </Text>
    </a>
  )
}
